let bootMode = null
let bootedUserId = null
let bootedUserHash = null

function log(action) {
	const { app_id } = getBaseSettings()
	if (!app_id) return
	console.info('[Intercom]', action)
}

function getIntercom() {
	return typeof window !== 'undefined' ? window.Intercom : undefined
}

function getBaseSettings() {
	return {
		api_base: process.env.VUE_APP_INTERCOM_API,
		app_id: process.env.VUE_APP_INTERCOM_ID,
	}
}

function applySettings(settings) {
	const merged = { ...getBaseSettings(), ...settings }
	if (typeof window !== 'undefined') {
		window.intercomSettings = merged
	}
	return merged
}

function markIdentified(user) {
	bootMode = 'identified'
	bootedUserId = user.id
	bootedUserHash = user.intercom_hash_web
}

export function shutdown() {
	const ic = getIntercom()
	if (ic) {
		ic('shutdown')
	}
	bootMode = null
	bootedUserId = null
	bootedUserHash = null
	log('shutdown')
}

export function bootAnonymous() {
	const ic = getIntercom()
	if (!ic) {
		log('boot-anonymous-skipped')
		return
	}

	shutdown()
	const settings = applySettings({})

	ic('boot', settings)
	bootMode = 'anonymous'
	log('boot-anonymous')
}

export function bootIdentified(user) {
	const ic = getIntercom()
	if (!ic) {
		log('boot-identified-skipped')
		return
	}

	if (!user?.id) {
		log('boot-identified-skipped')
		return
	}

	if (!user.intercom_hash_web) {
		log('boot-identified-skipped')
		return
	}

	if (
		bootMode === 'identified' &&
		bootedUserId === user.id &&
		bootedUserHash === user.intercom_hash_web
	) {
		log('boot-identified-skipped')
		return
	}

	const settings = applySettings({
		user_id: user.id,
		name: `${user.first_name} ${user.last_name}`,
		email: user.email,
		user_hash: user.intercom_hash_web,
	})

	if (bootMode === 'anonymous') {
		ic('hide')
		ic('update', settings)
		markIdentified(user)
		log('boot-identified-from-anonymous')
		return
	}

	if (bootMode === null) {
		ic('update', settings)
		markIdentified(user)
		log('boot-identified-from-widget')
		return
	}

	shutdown()
	ic('boot', settings)
	markIdentified(user)
	log('boot-identified')
}

export function updateRoute() {
	const ic = getIntercom()
	if (!ic || bootMode === null) return
	ic('update')
}

export function isReady() {
	return bootMode === 'identified'
}

export default {
	shutdown,
	bootAnonymous,
	bootIdentified,
	updateRoute,
	isReady,
}
